<template>
  <v-app>
    <!-- LOAD MODAL-->
    <v-dialog
      no-click-animation
      persistent
      v-model="dialog"
      :scrollable="true"
      width="300"
    >
      <v-card color="black" dark>
        <v-card-text>
          Loading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  data: function () {
    return {
      dialog: true,
    };
  },
};
</script>

<style></style>
